import { Locale } from '@headless-workspace/config';
import { mapStatusToSephoraCard, UserSephoraCardType } from '@headless-workspace/domain/common/server';
import { ArrayHelpers, LanguageHelpers } from '@headless-workspace/utils';
import { ReviewDTO } from '../ReviewDTO';
import { mapReviewPurchaserType, ReviewPurchaserType } from './ReviewPurchaserType';

export type ProductReview = {
    id?: string;
    rating: number;
    createdAt: Date;
    userName: string;
    userGender?: string;
    userAge?: string;
    userCard?: UserSephoraCardType;
    purchaserType: ReviewPurchaserType;
    purchaseProductSince?: string; // FIXME: rename to purchasedProductSince
    title: string;
    content?: string;
    isRecommended?: boolean;
    source?: {
        label: string;
        href: string;
    };
    vote: {
        like: number;
        dislike: number;
    };
    translatable: boolean;
};

export const mapReview = (dto: ReviewDTO, locale: Locale): ProductReview => {
    return {
        id: dto.id,
        rating: dto.rating,
        createdAt: new Date(dto.createdAt),
        userName: dto.userName ?? '',
        userGender: ArrayHelpers.findByKeyValue(dto.contextualData, 'id', 'Gender')?.label,
        userAge: ArrayHelpers.findByKeyValue(dto.contextualData, 'id', 'Age')?.label,
        userCard: mapStatusToSephoraCard(locale, dto.loyaltyStatus),
        purchaserType: mapReviewPurchaserType(dto.badge),
        purchaseProductSince: ArrayHelpers.findByKeyValue(dto.contextualData, 'id', 'ExperienceDachat')?.label,
        title: dto.title ?? '',
        content: dto.body ?? '',
        isRecommended: dto.isRecommended,
        source:
            dto.syndication && (dto.syndication.name || dto.syndication.url)
                ? {
                      label: dto.syndication?.name ?? '',
                      href: dto.syndication?.url ?? '',
                  }
                : undefined,
        vote: {
            like: dto.helpfulness.positiveCount,
            dislike: dto.helpfulness.negativeCount,
        },
        translatable: dto.locale
            ? LanguageHelpers.parseLanguage(dto.locale, '_') !== LanguageHelpers.parseLanguage(locale)
            : false,
    };
};
